import {
    GET_PDFINFO_STARTED,
    GET_PDFINFO_SUCESS,
    GET_PDFINFO_FAILED
} from '../actions/testPdfViewer';
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const pdfData = (state = intialData, action: any) => {
    switch (action.type) {
        case GET_PDFINFO_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_PDFINFO_SUCESS:
   // alert("GET_EMPLOYEEINFO_SUCESS action.payload");
   //  alert(JSON.stringify(action.payload));
   if (action.payload) {
    const report = new Blob([action.payload])
    const reportUrl = URL.createObjectURL(report)
    window.open(reportUrl, "_blank")
  }
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_PDFINFO_FAILED:
     return {
       ...state,
       isLoading: true,
     };
 default:
    return state;
}

}